<form [formGroup]="form">
  <div class="form-group">
    <div>
      <span>{{ field.label }}</span>
      <span class="text-danger">{{ field.required ? '*' : '' }}</span>
    </div>
    <input
      type="text"
      class="form-control"
      [class.is-invalid]="
        (form.controls.street.touched || form.controls.street.value) &&
        form.controls.street.errors
      "
      [class.is-valid]="
        form.controls.street.touched && form.controls.street.value !== undefined
      "
      formControlName="street"
      [attr.disabled]="disabled || null"
      placeholder="1234 Main St"
      ngx-gp-autocomplete
      [options]="options"
      (onAddressChange)="handleAddressChange($event)"
    />
  </div>
  <app-field-error
    [control]="form.controls.street"
    [field]="subfields[0]"
  ></app-field-error>
  <div class="form-row">
    <app-dynamic-field
      [ngClass]="subfields[1] | itemClass"
      [field]="subfields[1]"
      [control]="form | formControl: subfields[1].name"
      [disabled]="disabled"
      [markAsTouched]="markAsTouched"
    >
    </app-dynamic-field>
    <app-dynamic-field
      [ngClass]="subfields[2] | itemClass"
      [field]="subfields[2]"
      [control]="form | formControl: subfields[2].name"
      [disabled]="disabled"
      [markAsTouched]="markAsTouched"
    >
    </app-dynamic-field>
    <app-dynamic-field
      [ngClass]="subfields[3] | itemClass"
      [field]="subfields[3]"
      [control]="form | formControl: subfields[3].name"
      [disabled]="disabled"
      [markAsTouched]="markAsTouched"
    >
    </app-dynamic-field>
  </div>
</form>
